import { Box, Button, Checkbox, FormControl, FormControlLabel, FormGroup, IconButton, Input, InputAdornment, InputLabel, Tab, Tabs, TextField, Typography } from "@mui/material";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CheckIcon from "@mui/icons-material/Check";
import React, { useEffect, useState, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { login, loginFlagOff, loginWithFacebook, loginWithGoogle, signup, signupFlagOff } from "../../redux/actions/User";
import { useForm, Controller } from "react-hook-form";
import toast from "react-hot-toast";
import Cookies from "js-cookie";
import Circularbar from "../../components/circularbar/Circularbar";
import { useTranslation } from "react-i18next";
import { baseApi } from "../../api/endpoints";
import { signInWithPopup } from "firebase/auth";
import { fbAuth, provider } from "../../firbaseConfig";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import AuthLayout from "./Layout";
import vcpCanva from '../../images/canva-vcp-2.png'
import PairingCanva from "./Pairing";
import vcplogo from '../../images/VCPLogo.png'

const imNotArobotButtonStyles = {
    minWidth: "250px",
    height: "50px",
    padding: "10px",
    backgroundColor: "#F9F9F9",
    border: "1px solid #C1C1C1",
    borderRadius: "5px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    color: "#000",
    fontSize: "15px",
    cursor: "pointer"
}

function NewUser() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { auth, loging, loggedin, logFail, logBlocked, logout, isVerified, isRegistered, signupSppiner } = useSelector((state) => state.User);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [viewMode, setViewMode] = useState(0)
  const [role, setRole] = useState("user");
  const navigate = useNavigate();
  const {
    register,
    setValue,
    handleSubmit,
    getValues,
    reset,
    watch,
    control,
    formState: { errors },
  } = useForm({
    mode: "onTouched",
  });

  const [type, setType] = useState(true);
  const [confirmPasswordType, setConfirmPasswordType] = useState(true);

  useEffect(() => {
    const isOk = Cookies.get("vcpCredential");
    if (isOk !== undefined) {
      const d = JSON.parse(Cookies.get("vcpCredential"));
      setValue("email", d?.email);
      setValue("password", d?.password);
      setRememberMe(true);
    } else {
      setValue("email", "");
      setValue("password", "");
      setRememberMe(false);
    }
  }, []);

  const onSubmit = async (data) => {
    if (viewMode === 0) {
      dispatch(login(data.email, data.password));
      return;
    }
    try {
      await dispatch(
        signup({
          fullname: data.fullname,
          email: data.email,
          password: data.password,
          confirmPassword: data.confirmPassword,
          role: role,
          captcha: data.captcha
        })
      );
      reset({
        fullname: "",
        email: "",
        password: "",
        confirmPassword: "",
        captcha: ""
      });
    } catch (error) {
      if (error?.response?.data?.message) {
        dispatch(signupFlagOff());
        if (error.response.data.message == 'reCaptchaErr') {
          toast.error(t("views.signup.recaptchaFailed"))
        } else if (error.response.data.message == 'noReCaptcha') {
          toast.error(t("views.signup.recaptchaErr"))
        } else {
          toast.error(error.response.data.message);
        }
      }
    }
  };

  const ReCaptchaComponent = () => {
    const { executeRecaptcha } = useGoogleReCaptcha()
    const handleReCaptchaVerify = useCallback(async () => {
        if (!executeRecaptcha) {
            console.log('Execute recaptcha not yet available');
            return;
        }

        const token = await executeRecaptcha('yourAction');
        setValue('captcha', token)
    }, [executeRecaptcha]);
    return (
        <button style={imNotArobotButtonStyles} type="button" onClick={handleReCaptchaVerify}>
            <div style={{width: "30px", height: "30px", border: "2px solid #C1C1C1", borderRadius: "3px"}}>
                {watch("captcha") ? <CheckIcon color="success"/> : null}
            </div>
            I'm not a robot
            <img src="/images/recaptcha-icon.png" alt="" style={{width: "50px"}} />
        </button>
    )
  }

  const checkedRememberMe = (e) => {
    const { checked } = e.target;
    if (checked) {
      setRememberMe(true);
      Cookies.set("vcpCredential", JSON.stringify({ email: email, password: password }), { expires: 7 });
    } else {
      Cookies.remove("vcpCredential");
      setRememberMe(false);
    }
  };

  useEffect(() => {
    if (loggedin && !auth) {
        window.location.reload()
    }
  }, [loggedin])

  useEffect(() => {
    if (isRegistered) {
      toast.success(t("views.signup.accountCreated"));
      setViewMode(0);
      dispatch(signupFlagOff());
    }
  }, [isRegistered]);

  if (auth) {
    return (
      <AuthLayout>
        <PairingCanva />
      </AuthLayout>
    );
  }

  return (
    <>
        {loging && (
            <>
                <Box
                    sx={{
                        height: "100vh",
                        width: "100vw",
                        position: "absolute",
                        top: 0,
                        left: 0,
                        bottom: 0,
                        right: 0,
                        zIndex: 10000,
                        background: "rgba(0,0,0,0.5)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}>
                    <Circularbar />
                </Box>
            </>
        )}
        <AuthLayout hideLogo={true}>
            <img src={vcpCanva} />
            <Box>
                <Tabs onChange={(e, v) => setViewMode(v)} value={viewMode}>
                    <Tab label={"I have an account"} />
                    <Tab label={"I don't have an account"} />                 
                </Tabs>
            </Box>
            {viewMode == 0 ? (
                <form onSubmit={handleSubmit(onSubmit)} noValidate style={{width: '100%', maxWidth: "460px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "column",
                    gap: "20px",
                }}>
                    <TextField
                        {...register("email", {
                        required: true, pattern: {
                        value: /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
                        message: t("views.signup.invalidEmail")
                        }
                        })}
                        onChange={(e) => setEmail(e.target.value)}
                        variant={"standard"}
                        label={t("views.login.email")}
                        type={"email"}
                        fullWidth
                    />
                    {errors.email && (
                    <Typography sx={{ color: "warning.main" }}>{errors.email?.type == 'required' ? t("views.login.emailRequired") : errors.email.message}</Typography>
                    )}
                    
                    <FormControl variant={"standard"} fullWidth>
                        <InputLabel htmlFor="password">{t("views.login.password")}</InputLabel>
                        <Input
                        id="password"
                        type={type ? "password" : "text"}
                        sx={{ background: "transparent", color: "#313031" }}
                        {...register("password", {
                            required: true,
                            minLength: 6,
                        })}
                        onChange={(e) => setPassword(e.target.value)}
                        endAdornment={
                            <InputAdornment position={"end"} style={{ marginTop: "-10px", color: "#551fff" }}>
                            <IconButton aria-label="toggle password visibility" onClick={() => setType(!type)}>
                                {type ? <VisibilityOffIcon style={{ color: "#551fff" }} /> : <VisibilityIcon style={{ color: "#551fff" }} />}
                            </IconButton>
                            </InputAdornment>
                        }
                        />
                    </FormControl>
                    {errors.password && (
                    <Typography sx={{ color: "warning.main" }}>{errors.password?.type == 'required' ? t("views.login.passwordRequired") : errors.password?.type == "minLength" ? t("views.login.passToShort") : errors.password.message}</Typography>
                    )}

                    <Box sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        width: "100%"
                    }}>
                        {/* onChange={checkedRememberMe} checked={rememberMe ? true : false} */}
                        <FormGroup>
                        <FormControlLabel control={<Checkbox onChange={checkedRememberMe} checked={rememberMe ? true : false} />} style={{color: "#585858ff"}} label={t("views.login.rememberMe")} />
                        </FormGroup>
                        <Link to={"/forgetpassword"} style={{ textDecoration: "none", color: "#585858ff" }}>
                            {t("views.login.forgetPassword")}
                        </Link>
                    </Box>

                    <Box>
                        <Button variant="contained" type="submit" fullWidth sx={{
                            "&.Mui-disabled": {
                                background: "#d3d3d3ff",
                                color: "#919191ff"
                            }
                        }}>{t("views.login.login")}</Button>
                    </Box>

                    <Box sx={{
                        display: "flex",
                        justifyContent: "center",
                        gap: "10px"
                    }}>
                        <Typography sx={{
                        color: "#313031"
                        }}>{t("views.login.noAccount")}</Typography>
                        <Link to={'/signup'} style={{ textDecoration: "none", color: "#016AFE" }}>{t("views.login.createAccount")}</Link>
                    </Box>
                </form>                
            ) : (
                <form onSubmit={handleSubmit(onSubmit)} noValidate style={{width: '100%', maxWidth: "460px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "column",
                    gap: "20px",
                }}>
                    <TextField
                        {...register("fullname", {
                        required: true,
                        })}
                        variant={"standard"}
                        label={t("views.signup.fullName")}
                        type={"text"}
                        fullWidth
                    />
                    {errors.fullname && (
                        <Typography sx={{ color: "warning.main" }}>{errors.fullname?.type == 'required' ? t("views.signup.nameRequired") : errors.fullname.message}</Typography>
                    )}
                    
                    <TextField
                        {...register("email", {
                        required: true, pattern: {
                            value: /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
                            message: t("views.signup.invalidEmail")
                        }
                        })}
                        variant={"standard"}
                        label={t("views.login.email")}
                        type={"email"}
                        fullWidth
                    />
                    {errors.email && (
                        <Typography sx={{ color: "warning.main" }}>{errors.email?.type == 'required' ? t("views.login.emailRequired") : errors.email.message}</Typography>
                    )}
                    
                    <FormControl variant={"standard"} fullWidth>
                        <InputLabel htmlFor="password">{t("views.login.password")}</InputLabel>
                        <Input
                        id="password"
                        type={type ? "password" : "text"}
                        sx={{ background: "transparent", color: "#313031" }}
                        {...register("password", {
                            required: true,
                            minLength: 6,
                        })}
                        endAdornment={
                            <InputAdornment position={"end"} style={{ marginTop: "-10px", color: "#551fff" }}>
                            <IconButton aria-label="toggle password visibility" onClick={() => setType(!type)}>
                                {type ? <VisibilityOffIcon style={{ color: "#551fff" }} /> : <VisibilityIcon style={{ color: "#551fff" }} />}
                            </IconButton>
                            </InputAdornment>
                        }
                        />
                    </FormControl>
                    {errors.password && (
                        <Typography sx={{ color: "warning.main" }}>{errors.password?.type == 'required' ? t("views.login.passwordRequired") : errors.password?.type == "minLength" ? t("views.login.passToShort") : errors.password.message}</Typography>
                    )}

                    <FormControl variant={"standard"} fullWidth>
                        <InputLabel htmlFor="confirmPassword">{t("views.signup.confirmPassword")}</InputLabel>
                        <Input
                        id="confirmPassword"
                        type={confirmPasswordType ? "password" : "text"}
                        sx={{ color: "#313031" }}
                        {...register("confirmPassword", {
                            required: true,
                            validate: (value) => value === getValues("password") || t("views.signup.passwordMismatch"),
                        })}
                        endAdornment={
                            <InputAdornment position={"end"} style={{ marginTop: "-10px", color: "#551fff" }}>
                            <IconButton aria-label="toggle password visibility" onClick={() => setConfirmPasswordType(!confirmPasswordType)}>
                                {confirmPasswordType ? <VisibilityOffIcon style={{ color: "#551fff" }} /> : <VisibilityIcon style={{ color: "#551fff" }} />}
                            </IconButton>
                            </InputAdornment>
                        }
                        />
                    </FormControl>
                    {errors.confirmPassword && (
                        <Typography color="warning.main">{errors.confirmPassword?.type == "required" ? t("views.login.passwordRequired") : errors.confirmPassword?.message}</Typography>
                    )}

                    <Box
                        sx={{
                        height: "50px",
                        width: "100%",
                        margin: "5px auto",
                        display: "flex",
                        flexDirection: "column",
                        }}>
                        <Box
                        sx={{
                            alignItems: "center",
                            display: "flex",
                            ml: "-9px",
                            width: "100%",
                        }}>
                        <Controller
                            control={control}
                            name={"policy"}
                            defaultValue={false}
                            rules={{ required: true }}
                            render={({ field }) => (
                            <>
                                <Checkbox {...field} />
                                <Typography color="text.secondary" variant="body1">
                                I have read the <a href="https://vcplayer.com/terms-and-conditions">Terms and Conditions</a>
                                </Typography>
                            </>
                            )}
                        />
                        </Box>
                        <Typography sx={{ color: "error.main" }}>{errors?.policy && "You need to accept Terms and Conditions"}</Typography>
                    </Box>

                    <Box
                        sx={{
                        height: "50px",
                        }}>
                        <ReCaptchaComponent />
                    </Box>

                    <Box>
                        <Button variant="contained" type="submit" fullWidth sx={{
                            "&.Mui-disabled": {
                                background: "#d3d3d3ff",
                                color: "#919191ff"
                            }
                        }}>{t("views.signup.signUp")}</Button>
                    </Box>

                    <Box sx={{
                        display: "flex",
                        justifyContent: "center",
                        gap: "10px"
                    }}>
                        <Typography sx={{
                            color: "#313031"
                        }}>{t("views.signup.backToLogin")}</Typography>
                        <Link to={'/login'} style={{ textDecoration: "none", color: "#016AFE" }}>{t("views.signup.login")}</Link>
                    </Box>
                </form>                
            )}
        </AuthLayout>
    </>
  );
}

export default NewUser;
